import { Expose } from 'class-transformer'
import type { PermissionNameType } from '@interfaces/permission/PermissionNameType'

export class PermissionType {
  @Expose() status: boolean

  @Expose() name: PermissionNameType

  @Expose() actions: string[]
}
